import { z } from 'zod/v3';
// Article Schema
export const AdmonitionSchema = z.object({
  type: z.enum(['note', 'tip', 'info', 'warning', 'danger']),
  title: z.string().optional().describe('The title of the admonition, if necessary'),
  content: z.string().describe('The content of the admonition. Can use markdown formatting. Can have multiple paragraphs.'),
});

export const ArticleStepSchema = z.object({
  id: z.string().describe('The id of the step, must be STEP ID verbatim'),
  title: z.string().describe('The title of the step, must be short and concise, describe what the step is about. No more than 20 words'),
  guideAction: z.string().optional().describe('Short, clear, action-oriented instruction for the step (e.g., "Click Submit Button", "Enter your email")'),
  description: z.string().describe('The description of the step. Can use markdown formatting. Can have multiple paragraphs.'),
  screenshots: z.array(z.string()).describe('The screenshots of the step, must be STEP ID verbatim'),
  admonitions: z.array(AdmonitionSchema).optional().describe('The admonitions of the step, if necessary, to highlight the important points in the step'),
});
export type ArticleStep = z.infer<typeof ArticleStepSchema>;

export const ArticleGenerationSchema = z.object({
  title: z.string().describe('The title of the article, must be short and concise, no more than 10 words'),
  description: z.string().describe('The description of the article. Can use markdown formatting. Can have multiple paragraphs.'),
  admonitions: z.array(AdmonitionSchema).optional().describe('The admonitions, if necessary, to highlight the important points in the article'),
  steps: z.array(ArticleStepSchema).describe("Array of steps, each step is an object with id, title, description, screenshots, and admonitions. Steps are ordered by the timestamp."),
  footer: z.string().describe('The footer of the article. Can use markdown formatting. Can have multiple paragraphs.'),
  suggestedTopics: z.array(z.string()).describe('The suggested topics of the article, no more than 5 topics'),
});
export type ArticleGenerationSchemaType = z.infer<typeof ArticleGenerationSchema>;